import { useAuthenticator } from "@aws-amplify/ui-react";
import { Box, Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import { isAdmin } from "../utilities";
import BasicTable from "../components/BasicTable";
import { useState } from "react";
import UserDropdown from "../components/UserDropdown";

const QuestionBankPage: React.FC = () => {
  const [selectedUser, setSelectedUser] = useState<string>("");
  const { user } = useAuthenticator();
  return (
    <>
      {isAdmin(user) && (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
          <Button
            component={NavLink}
            to="/questionBank/create"
            variant="contained"
          >
            Add Question
          </Button>
          <UserDropdown user={selectedUser} setUser={setSelectedUser} />
        </Box>
      )}
      <BasicTable selectedUser={selectedUser} />
    </>
  );
};

export default QuestionBankPage;
